import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import { workspaceActions, workspaceFormActions } from '../constants';

const useShowWorkspaceRequestReceipt = () => {
  const handler = useDispatch();
  return useCallback(({ name, text }) => handler({
    type: workspaceFormActions.SHOW_WORKSPACE_REQUEST_RECEIPT,
    name,
    text,
  }), []);
};

const useDestroyRequestWorkspace = ({ code }) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: workspaceActions.DESTROY_REQUEST_WORKSPACE, code }), [code]);
};

const useRequestWorkspace = ({ code }) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: workspaceActions.REQUEST_WORKSPACE, code }), [code]);
};

export default {
  useDestroyRequestWorkspace,
  useHideWorkspaceRequestReceipt: () => events.useSimpleDispatch(workspaceFormActions.HIDE_WORKSPACE_REQUEST_RECEIPT),
  useRequestWorkspace,
  useShowWorkspaceRequestReceipt,
};
